module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_NewDocument_16"],"path":[{"$":{"d":"M11.5,7A4.5,4.5,0,1,0,16,11.5,4.5,4.5,0,0,0,11.5,7ZM14,12H12v2H11V12H9V11h2V9h1v2h2Z","fill":"#464646"}},{"$":{"d":"M8,5H4V4H8ZM6.63,8H4V9H6.05A6,6,0,0,1,6.63,8ZM9.11,6H4V7H7.54A6,6,0,0,1,9.11,6ZM6.05,14H2V2H8.3L12,5v.56a6,6,0,0,1,2,.53V4L9,0H0V16H7.54A6,6,0,0,1,6.05,14Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_NewDocument_16.svg
// module id = rBul
// module chunks = 1